import { BaseException } from "@/exceptions/base-exception.exception.ts"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights.ts"
import type { WorkPeriod } from "@/models/work-period.model.ts"

export class OverlappingWorkPeriodException extends BaseException {
  exceptionId = "OVERLAPPING_WORK_PERIODS"
  title = "Overlappende dienst"
  weight = ExceptionWeights.ERROR

  private readonly conflictingWorkPeriods: WorkPeriod[]

  constructor(conflictingWorkPeriods: WorkPeriod[]) {
    super()
    this.conflictingWorkPeriods = conflictingWorkPeriods
  }

  public getMessage(): string {
    const { conflictingWorkPeriods } = this

    if (conflictingWorkPeriods.length === 1) {
      const workPeriod = conflictingWorkPeriods[0]
      return `Deze dienst overlapt met een andere dienst van ${workPeriod.timeStart?.format("HH:mm")} uur tot ${workPeriod.timeEnd?.format("HH:mm")} uur.`
    }

    return `Deze dienst overlapt met andere diensten:
          ${conflictingWorkPeriods
            .map((workPeriod) => {
              return `- ${workPeriod.timeStart?.format("HH:mm")} uur tot ${workPeriod.timeEnd?.format("HH:mm")} uur`
            })
            .join("\n")}`
  }
}
